import React, { memo } from 'react';
import { eqProps } from 'ramda';
import { usePortletTranslations } from '@core/js/components/system/Portlet';
import { Icon } from '@core/js/components/common/Icon';

import style from './index.scss';

export default memo(({ expanded, onClick, gameAmount }) => {
    const t = usePortletTranslations();
    return (
        <div className={style.toggleAllGames} onClick={onClick}>
            {t(`games.${expanded ? 'viewLess' : 'viewMore'}`)}
            {gameAmount > 0 && <p className={style.toggleGameAmount}>({gameAmount})</p>} {/* Solverde changes */}
            <Icon type="showMoreArrow" className={style.icon} />
        </div>
    );
}, eqProps('expanded'));
